import(/* webpackMode: "eager" */ "/home/web/jfit/apps/web/src/app/global-error.tsx");
